module.exports = __webpack_public_path__ + "img/contract.9c10484b.png";